import styled from 'styled-components';
import formControlMixin from './formControlMixin';

const TextArea = styled.textarea`
  ${formControlMixin}
`;

export default TextArea;
